import { createFileRoute } from '@tanstack/react-router';

import { AnnouncementTab } from '@apps/web/components/training/announcement_tab';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';

export const Route = createFileRoute('/_app/(main)/training/announcement')({
    component: AnnouncementRoute,
});

function AnnouncementRoute() {
    const organizationId = useOrganizationId();

    if (!organizationId) {
        return (
            <div className="text-muted-foreground text-sm">
                Select an organization to view the announcement email.
            </div>
        );
    }

    return <AnnouncementTab organizationId={organizationId} />;
}
